import React, { useState, useMemo, useCallback } from 'react';

import BrowserOnly from 'components/consumer/BrowserOnly';
import UpdateZipcodeSidebar from 'components/consumer/UpdateZipcodeSidebar';
import useZipCode from 'global-state/zipCode/useZipCode';
import useIsZipCodeFromUserServiceable from 'global-state/isZipCodeFromUserServiceable/useIsZipCodeFromUserServiceable';
import useZipCodeFromUser from 'global-state/zipCodeFromUser/useZipCodeFromUser';
import useUserLocation from 'global-state/userLocation/useUserLocation';
import useUserLocationLoading from 'global-state/userLocationLoading/useUserLocationLoading';
import PDPZipCodeEditLocationUI from './PDPZipCodeEditLocationUI';

const PDPZipCodeEditLocation = () => {
  const zipCode = useZipCode();
  const zipCodeFromUser = useZipCodeFromUser();
  const userLocation = useUserLocation();
  const isLocationLoading = useUserLocationLoading();
  const [isUpdateZipcodeOpen, setIsUpdateZipcodeOpen] = useState(false);

  const toggleUpdateZipCodeSidebar = useCallback(() => {
    setIsUpdateZipcodeOpen(prevIsUpdateZipcodeOpen => !prevIsUpdateZipcodeOpen);
  }, []);

  const {
    address: locationAddress,
    city: locationCity,
    country: locationCountry,
    state: locationState,
    stateShortName: locationStateShortName,
  } = userLocation;

  const isUserInUS = locationCountry === 'United States';

  const locationToShow = useMemo(() => {
    if (locationState) {
      return `${
        locationCity
          ? `${locationCity}, ${locationStateShortName || locationState}`
          : `${locationStateShortName || locationState}`
      }`;
    }

    return locationAddress?.replace('United States', 'US') || zipCode;
  }, [
    locationAddress,
    locationCity,
    locationState,
    locationStateShortName,
    zipCode,
  ]);

  const isZipCodeFromUserServiceable = useIsZipCodeFromUserServiceable();

  return (
    <>
      <BrowserOnly>
        <UpdateZipcodeSidebar
          isZipcodeFormOpen={isUpdateZipcodeOpen}
          onClose={toggleUpdateZipCodeSidebar}
        />
      </BrowserOnly>

      <PDPZipCodeEditLocationUI
        isLoading={isLocationLoading}
        isUserInUS={isUserInUS}
        isZipCodeFromUserServiceable={isZipCodeFromUserServiceable}
        locationToShow={locationToShow}
        toggleUpdateZipCodeSidebar={toggleUpdateZipCodeSidebar}
        zipCodeFromUser={zipCodeFromUser}
      />
    </>
  );
};

export default React.memo(PDPZipCodeEditLocation);
